var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.tmpNo != null
        ? _c("div", { attrs: { name: "tmpNo-block" } }, [
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("资产名称")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("label", { staticClass: "mr20" }, [
                  _vm._v(_vm._s(_vm.shopDeviceSvcSubNoInfo.title || ""))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("系统编号")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("label", { staticClass: "mr20" }, [
                  _vm._v(_vm._s(_vm.shopDeviceSvcSubNoInfo.tmpNo || ""))
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("swb-result-table", {
        ref: "result_table",
        attrs: {
          name: "result_table",
          confKey: _vm.resultKey,
          configAuto: true,
          needPager: _vm.needPager,
          multiSelect: _vm.multiSelect,
          multiPageSelect: _vm.multiPageSelect,
          rowKeyPropName: _vm.rowKeyPropName,
          rowNoShow: _vm.rowNoShow,
          rowNoFixed: _vm.rowNoFixed,
          height: _vm.tableHeight,
          pageNoChangeHandler: _vm.pageNoChangeHandler,
          rowDblClickHandler: _vm.rowDblClickHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-808ab80c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-808ab80c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/workVoucher/DeviceRepairRecList.vue
// module id = 1875
// module chunks = 1